import type {ReactElement} from 'react';
import {AddButton} from '@Components/add-button';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize, TextType} from '@Components/text';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {openEmailMakerBlockManagerModal} from '@Components/modals/email-maker-block-manager-modal/email-maker-block-manager-modal';
import {setSelectedBlockPanel} from '@Components/email-maker-block-manager/email-maker-block-manager-reducer';
import {unselectComponent} from '@EmailMakerReact/lib/email-maker-selection-library';
import {useAppDispatch} from '@/hooks';
import type {AddClearButtonProps} from './add-clear-button.types';
import styles from './add-clear-button.module.scss';

export function EmailMakerAddClearButton({editor, isComponentSelected}: AddClearButtonProps): ReactElement {
  const dispatch = useAppDispatch();

  const onAdd = (): void => {
    dispatch(setSelectedBlockPanel(null));
    openEmailMakerBlockManagerModal();
  };

  const onClearSelection = (): void => {
    if (editor) {
      unselectComponent(editor);
    }
  };

  return (
    <div className={styles.addButton}>
      <div className={styles.wrapperContainer}>{renderContent(isComponentSelected, onAdd, onClearSelection)}</div>
    </div>
  );
}

function renderContent(isComponentSelected: boolean, onAdd: () => void, onClearSelection: () => void): ReactElement {
  if (isComponentSelected) {
    return (
      <ClickableDiv className={`_full-width _full-height flex-v-row flex-center ${styles.clearSelection}`} onClick={onClearSelection}>
        <div className={`flex-center radius-round ${styles.clearSelectionButton}`}>
          <Icon icon="icon-clear-selection" size={IconSize.SIZE_ICON_24} />
        </div>
        <Text className="text-center" val={window.i18next.t('pmwjs_clear_selection')} size={TextSize.SM} type={TextType.BODY} />
      </ClickableDiv>
    );
  }

  return (
    <>
      <div className="flex-center _full-width">
        <AddButton onClick={onAdd} />
      </div>
      <Text className={styles.addText} val={window.i18next.t('pmwjs_add_capitalized')} size={TextSize.XXSMALL} />
    </>
  );
}
